import React from 'react';

const CheckBoxList = (props) => {

    function handleChangeLocally(event) {
        props.handleChange(event.target.checked, props.item.id)
    }

    return (
        <tr>
            <th scope="row">
                <div className="custom-control custom-control-alternative custom-checkbox">
                    <input
                        className="custom-control-input"
                        id={props.item.id}
                        onChange={e => handleChangeLocally(e)}
                        checked={props.selected === true}
                        type="checkbox"
                    />
                    <label className="custom-control-label" htmlFor={props.item.id}>
                        {props.item.label}
                    </label>
                </div>
            </th>
        </tr>
    )
};

export default CheckBoxList;